import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class Controls extends BaseOption {
  static userInterfaceComponent = {
    label: "Controls",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          icon: "mdi:controller",
          tooltip: "Controls On",
          value: "Yes",
        },
        {
          icon: "mdi:controller-off",
          tooltip: "Controls Off",
          value: "No",
        },
      ],
    },
  };

  static defaultValue = "Yes";

  static convertConfigValueToCompiledValue(configValue) {
    return configValue === "Yes";
  }
}
